const { createMockGenerator } = require("../utils/mockData")

const generateMockTestimonials = createMockGenerator(index => ({
  id: index,
  image: null,
  name: "Gbajamila boboyi",
  testimonial:
    "A breakthrough health and youth preservation system, based on highly innovative and award winning plant stem cell science Phytocelltec Malus Domestica, clinic proven to rejuvenate and revitalize epidermal stem cells and tissues regeneration for a healthier, stronger and younger looking you.",
}))

export const testimonials = generateMockTestimonials(3)
